export const NETWORK_GRAPH = 'ENUM_TABTYPE_NETWORKGRAPH';
export const NETWORK_GRAPH_APP_NAME = 'appNetworkGraph';
export const NETWORK_GRAPH_ID = 'networkGraph';
export const NETWORK_GRAPH_TYPE = 'NetworkGraph';
